/**
 * FontAwesome Icon Library
 * File: src/fontawesome.js
 *
 * Central configuration for all FontAwesome icons used in the app.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser,
  faWallet,
  faHandHoldingUsd,
  faBullseye,
  faBalanceScale,
  faCheckCircle,
  faArrowRight,
  faArrowLeft,
  faSpinner,
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faChartPie,
  faShieldAlt,
  faFileAlt,
  faRedo,
  faCog,
  faCoins,
  faPiggyBank,
  faChartLine,
  faPercentage,
  faCalendarAlt,
  faMoneyBillWave,
  faGraduationCap,
  faHome,
  faCar,
  faHeartbeat,
  faBriefcase,
  faUniversity,
  faLock,
  faKey,
  faSignInAlt,
  faSignOutAlt,
  faUserCircle,
  faLayerGroup,
  faGift,
  faTimes,
  faCheck,
  faPrint,
  faDownload,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faBuilding,
  faClock,
  faStar,
  faThumbsUp,
  faThumbsDown,
  faQuestion,
  faQuestionCircle,
  faClipboardList,
  faPlus,
  faMinus,
  faEdit,
  faTrash,
  faSave,
  faSearch,
  faFilter,
  faSort,
  faList,
  faTh,
  faEye,
  faEyeSlash,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faBars,
  faEllipsisV,
  faExpandAlt,
  faCompressAlt,
  faMoneyBill1,
  faHeart,
  faUsers,
  faGlobe,
  faSyncAlt,
  faCreditCard,
  faExchangeAlt,
  faHouse,
  faShoppingBag,
  faCalendarCheck, faPoundSign, faHandshake
} from '@fortawesome/free-solid-svg-icons';

import {
  faQuestionCircle as farQuestionCircle,
  faCheckCircle as farCheckCircle,
  faTimesCircle as farTimesCircle,
  faFileAlt as farFileAlt,
  faClipboard as farClipboard,
  faCalendarAlt as farCalendarAlt,
  faUser as farUser
} from '@fortawesome/free-regular-svg-icons';

// Add all icons to the library
library.add(
    // Solid icons
    faUser,
    faWallet,
    faHandHoldingUsd,
    faBullseye,
    faBalanceScale,
    faCheckCircle,
    faArrowRight,
    faArrowLeft,
    faSpinner,
    faInfoCircle,
    faExclamationTriangle,
    faExclamationCircle,
    faChartPie,
    faShieldAlt,
    faFileAlt,
    faRedo,
    faCog,
    faCoins,
    faPiggyBank,
    faChartLine,
    faPercentage,
    faCalendarAlt,
    faMoneyBillWave,
    faMoneyBill1,
    faGraduationCap,
    faHeart,
    faHome,
    faCar,
    faHeartbeat,
    faBriefcase,
    faUniversity,
    faLock,
    faKey,
    faSignInAlt,
    faSignOutAlt,
    faUserCircle,
    faLayerGroup,
    faGift,
    faTimes,
    faCheck,
    faPrint,
    faDownload,
    faEnvelope,
    faPhone,
    faMapMarkerAlt,
    faBuilding,
    faClock,
    faStar,
    faThumbsUp,
    faThumbsDown,
    faQuestion,
    faQuestionCircle,
    faClipboardList,
    faPlus,
    faMinus,
    faEdit,
    faTrash,
    faSave,
    faSearch,
    faFilter,
    faSort,
    faList,
    faTh,
    faHandshake,
    faEye,
    faEyeSlash,
    faChevronDown,
    faChevronUp,
    faChevronLeft,
    faChevronRight,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faBars,
    faPoundSign,
    faCalendarCheck,
    faShoppingBag,
    faEllipsisV,
    faExpandAlt,
    faCompressAlt,
    faUsers,
    faExchangeAlt,
    faBriefcase,
    faHouse,
    faGlobe,
    faSyncAlt,
    faCreditCard,
    // Regular icons
    farQuestionCircle,
    farCheckCircle,
    farTimesCircle,
    farFileAlt,
    farClipboard,
    farCalendarAlt,
    farUser
);